var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    id: "fail",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.91 53.91a5.93 5.93 0 0 1-4.24-1.76l-4.32-4.32A2 2 0 0 1 42.17 45l4.33 4.32a2 2 0 0 0 2.82 0 2 2 0 0 0 0-2.82L36.24 33.41a2 2 0 0 1 0-2.82L49.32 17.5a2 2 0 0 0 0-2.82 2 2 0 0 0-2.82 0L33.41 27.76a2 2 0 0 1-2.82 0L17.5 14.68a2 2 0 0 0-2.82 0 2 2 0 0 0 0 2.82l13.08 13.09a2 2 0 0 1 0 2.82L14.68 46.5a2 2 0 0 0 0 2.82 2 2 0 0 0 2.82 0l13.09-13.08a2 2 0 0 1 2.82 0l2.44 2.44A2 2 0 0 1 33 41.51l-1-1-11.67 11.64a6 6 0 1 1-8.48-8.48L23.51 32 11.85 20.33a6 6 0 1 1 8.48-8.48L32 23.51l11.67-11.66a6 6 0 1 1 8.48 8.48L40.49 32l11.66 11.67a6 6 0 0 1-4.24 10.24Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFail);
export default __webpack_public_path__ + "static/media/fail.bedab6c82cf17282750c3f498628c5f9.svg";
export { ForwardRef as ReactComponent };